import React from 'react'
import {Link as GatsbyLink} from 'gatsby'

const Link = ({linkToMainSite, to, title, children}) => (
    <>
        {linkToMainSite ?
            <a href={`https://www.burdasolutions.com${to}`}
               title={title}
               target="_blank"
               rel="noreferrer noopener"
            >
                {children}
            </a>
            :
            <GatsbyLink to={to} title={title}>{children}</GatsbyLink>
        }
    </>
);

const Footer = ({linkToMainSite, imprintLabel, contactLabel, dataProtectionLabel, accessibilityLabel, ContactLink}) => (
    <footer>
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <ul className="footer-links">
                        <li>
                            <ContactLink to="/kontakt" title={contactLabel + ' aufrufen'}>
                                <span>{contactLabel}</span>
                            </ContactLink>
                        </li>
                        <li>
                            <Link linkToMainSite={linkToMainSite}
                                  to="/impressum"
                                  title={imprintLabel + ' aufrufen'}
                            >
                                <span>{imprintLabel}</span>
                            </Link>
                        </li>
                        <li>
                            <Link linkToMainSite={linkToMainSite}
                                  to="/datenschutz"
                                  title={dataProtectionLabel + ' aufrufen'}
                            >
                                <span>{dataProtectionLabel}</span>
                            </Link>
                        </li>
                        <li>
                            <Link linkToMainSite={linkToMainSite}
                                  to="/barrierefreiheit"
                                  title={accessibilityLabel + ' aufrufen'}
                            >
                                <span>{accessibilityLabel}</span>
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="col-lg-4">
                    <div className="footer-connect">
                    Connect with BurdaSolutions

                        <div className="connections">
                            <a href="https://www.xing.com/companies/burdadigitalsystemsgmbh"
                               title="Zu Xing"
                               target="_blank"
                               rel="noreferrer noopener"
                            >
                                <i className="icon xing" />
                            </a>

                            <a href="https://www.kununu.com/de/burda-digital-systems"
                               title="Zu kununu"
                               target="_blank"
                               rel="noreferrer noopener"
                            >
                                <i className="icon kununu" />
                            </a>

                            <a href="https://www.linkedin.com/company/burda-digital-systems-gmbh"
                               title="Zu LinkedIn"
                               target="_blank"
                               rel="noreferrer noopener"
                            >
                                <i className="icon linkedin" />
                            </a>

                            <a href="https://www.instagram.com/burdasolutions/"
                               title="Zu Instagram"
                               target="_blank"
                               rel="noreferrer noopener"
                            >
                                <i className="icon instagram" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-6">
                    <div className="footer-copyright">
                        © Burda Digital Systems GmbH
                    </div>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer
